import normalizeHeight from '@fr/normalize-height';
import videoIframe from '@fr/video-iframe';

// On document ready
$(() => {

  // Trick to have the Videos on Jobs page to resize properly according to
  // viewport.
  const videos = document.querySelectorAll('.js-video-iframe'); 

  if(videos.length > 0) {
    Array.prototype.forEach.call(videos, function (video) {
      videoIframe(video);
    });
  }

  // Normalizes the company value boxes to be the same height.

  normalizeHeight($('.js-company-value'));

});
